export const throwAPIError = statusRegex => fetch => {
  return async (...args) => {
    const resp = await fetch(...args);
    const { status } = resp;
    if (statusRegex.test(status)) {
      const err = new Error(`${status} status`);
      err.response = resp;
      throw err;
    }
    return resp;
  };
};

export const throw400s = throwAPIError(/4\d\d/);
export const throw500s = throwAPIError(/5\d\d/);

export default throwAPIError;
